<template>
  <div style="height:500px;margin-top:100px">
      <VueSlickCarousel v-bind="slickOptions">
            <div><img src="../assets/img/slide1.png" alt=""> </div>
            <div><img src="../assets/img/slide1.png" alt=""> </div>
            <div><img src="../assets/img/slide1.png" alt=""> </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
  // optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
export default {
    components: { VueSlickCarousel },
    data() {
        return {
            slickOptions: {
                dots: true,
                edgeFriction: 0.35,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                adjustableHeight:false
            }
        }
    },
}
</script>

<style>

</style>